// extracted by mini-css-extract-plugin
export default {"btnFlex":"LoginButton_btnFlex__V-+1B","loginBtn":"LoginButton_loginBtn__OdCr1","signUpBtn":"LoginButton_signUpBtn__AjPys"};